import { getDefaultExportFromCjs as t } from "../../_virtual/_commonjsHelpers.js";
import { r as e } from "../../_virtual/index2.js";
import { __require as o } from "./lib/react-input-mask.production.min.js";
import { __require as p } from "./lib/react-input-mask.development.js";
(function(r) {
  process.env.NODE_ENV === "production" ? r.exports = o() : r.exports = p();
})(e);
const u = /* @__PURE__ */ t(e.exports);
export {
  u as default
};
//# sourceMappingURL=index.js.map
